/**
 * «Озвучить сообщение» — как в Discord: голосом системы, по-русски, если такой
 * голос есть. Новое озвучивание обрывает прежнее, а не встаёт в очередь.
 */
export function canSpeak(): boolean {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

export function speak(text: string): void {
  if (!canSpeak() || !text.trim()) return;
  const synth = window.speechSynthesis;
  synth.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "ru-RU";
  const voice = synth.getVoices().find((item) => item.lang.toLowerCase().startsWith("ru"));
  if (voice) utterance.voice = voice;
  synth.speak(utterance);
}
